import { cn } from "@/lib/utils";
import { format } from "date-fns";
import { arSA, enUS } from "date-fns/locale";
import { useLocale } from "next-intl";
import React from "react";

const TimeOfMsg = ({ className, id }: { className?: string; id: number }) => {
  const locale = useLocale();
  return (
    id && (
      <p className={cn("text-[#333] text-[10px] sm:text-sm", className)}>
        {format(new Date(Number(id)), "hh:mm a", {
          locale: locale === "ar" ? arSA : enUS,
        })}
      </p>
    )
  );
};

export default TimeOfMsg;
